import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface UpdateLosFieldsParams {
  loanId: string;
  extractedDataIds?: string[];
}

export interface UpdateLosFieldsResponse {
  success: boolean;
  message?: string;
  documentsProcessed?: number;
  skipped?: boolean;
}

const updateLosFields = async (
  params: UpdateLosFieldsParams,
): Promise<UpdateLosFieldsResponse> => {
  if (isMockServices()) {
    return await mock({
      success: true,
      message: 'LOS fields updated successfully',
    });
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<UpdateLosFieldsResponse>(
    `/los/encompass/loans/${params.loanId}/fields/update`,
    {
      method: 'POST',
      body: params.extractedDataIds
        ? { extractedDataIds: params.extractedDataIds }
        : undefined,
    },
  );

  if (response.data) return response.data;
  throw new Error('Failed to update LOS fields');
};

export default updateLosFields;
